export const GitHubIcon = (props) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M12 2C6.477 2 2 6.477 2 12C2 16.418 4.865 20.167 8.839 21.565C9.339 21.658 9.5 21.358 9.5 21.098V19.315C6.731 19.940 6.139 18.094 6.139 18.094C5.683 17.020 5.029 16.723 5.029 16.723C4.132 16.113 5.096 16.126 5.096 16.126C6.085 16.196 6.618 17.138 6.618 17.138C7.500 18.585 8.977 18.140 9.543 17.889C9.637 17.239 9.903 16.793 10.196 16.548C7.984 16.302 5.650 15.466 5.650 11.661C5.650 10.570 6.044 9.677 6.638 8.979C6.533 8.731 6.181 7.761 6.738 6.323C6.738 6.323 7.566 6.059 9.500 7.412C10.294 7.192 11.150 7.081 12 7.078C12.850 7.081 13.705 7.192 14.500 7.412C16.434 6.059 17.262 6.323 17.262 6.323C17.819 7.761 17.467 8.731 17.362 8.979C17.956 9.677 18.350 10.570 18.350 11.661C18.350 15.476 16.011 16.299 13.793 16.539C14.155 16.838 14.500 17.448 14.500 18.361V21.098C14.500 21.362 14.659 21.665 15.167 21.564C19.137 20.163 22 16.417 22 12C22 6.477 17.523 2 12 2Z"
      fill="currentColor"
    />
  </svg>
);

GitHubIcon.displayName = "GitHubIcon";

export default GitHubIcon;
